import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

const input_names = ["name","data_source", "allow_special_characters", "length", "static_value", "notes"]

export default class extends Controller {
  static values = {
    schemaId: String
  }
  
  static targets = ["templatesContainer", "standardFieldsContainer"];

  connect(){
    this.initializeSortLogic()
  }
  
  initializeSortLogic(){
    const schemaId = this.schemaIdValue
    if ($("#templates-sortable").length > 0) {
      $("#templates-sortable").sortable({
        axis: "y",
        items: ".item",
        cursor: "move",
        sort: function (e, ui) {
          return ui.item.addClass("active-item-shadow");
        },
        stop: function (e, ui) {
          ui.item.removeClass("active-item-shadow");
          return ui.item.children("td").effect("highlight", {}, 1000);
        },
        update: function (e, ui) {
          var previewData = [];
          $("#templates-sortable").find(".template-card").each( (index, template_card) => {
            var template_card = $($(this).find(".template-card")[index])
            var current_template = {"index": index}
            
            // change id of card to new index:
            template_card.attr("id", `template_card_${index}`)

            // change name of various inputs on card to new index: 
            input_names.forEach(input_name => {
              var input = template_card.find(`[name*="${input_name}"]`)
              if (input.length > 0){
                var name = `${input_name}_${index}`
                template_card.find(`[name*="${input_name}"]`).attr("name", name)
                template_card.find(`[name*="${input_name}"]`).attr("id", name)
                if (["data_source", "joiner_type"].includes(input_name)){
                  current_template[input_name] = template_card.find(`[name*="${input_name}"]`)[0].value
                }
              }
            });
            previewData.push(current_template)
          })
          get(`/barcode_schemas/${schemaId}/update_plan_preview?template_data=${JSON.stringify(previewData)}`, { responseKind: 'turbo-stream' })
        },
      });
    }
  }

  updateTemplateFormTurboFrame(event) {
    var data = {}
    var templateData = [];
    templateData = this.gatherTemplateData(templateData)

    data['templateData'] = templateData
    data['action'] = $(event.target)[0].getAttribute("action")
    data['target'] = $(event.target)[0].getAttribute("target")
    
    document.getElementById("template_data_for_turbo").value = JSON.stringify(data)
    document.getElementById("template-turbo-form").requestSubmit();
  }

  changeDataSource(event){
    const target_card = event.target.closest(".template-card").id
    var templateData = JSON.stringify(this.gatherSingleCardData([]))
    get(`/barcode_schemas/${this.schemaIdValue}/load_template_card?data_source=${event.target.value}&target_card=${target_card}&template_data=${templateData}`, { responseKind: 'turbo-stream' })
  }

  submitUpdate(event){
    event.preventDefault();

    var data = {}
    var templateData = [];
    templateData = this.gatherTemplateData(templateData)

    data['templateData'] = templateData
    data['action'] = $(event.target)[0].getAttribute("action")
    data['target'] = $(event.target)[0].getAttribute("target")
    
    document.getElementById("template_data_for_update").value = JSON.stringify(data)
    document.getElementById("template-update-form").requestSubmit();
  }
  
  gatherTemplateData(templateData){
    $(this.templatesContainerTarget).find('.template-card').each((index, template_card) => {
      var current_template = {}
      current_template["index"] = index
      input_names.forEach(input_name => {
        var input = document.getElementsByName(`${input_name}_${index}`)[0]
        if (input != undefined ) {
          current_template[input_name] = input.value
        }
      });
      templateData.push(current_template);
    });
    return templateData
  }

  gatherSingleCardData(data){
    $(this.templatesContainerTarget).find('.template-card').each((index, template_card) => {
      var current_template = {}
      current_template["index"] = index
      var data_source_input = document.getElementsByName(`data_source_${index}`)[0]
      if (data_source_input != undefined ) {
        current_template["data_source"] = data_source_input.value
      }
      input_names.forEach(input_name => {
        var input = document.getElementsByName(`${input_name}_${index}`)[0]
        if (input != undefined ) {
          current_template[input_name] = input.value
        }
      });
      data.push(current_template);
    });
    return data
  }
}
